import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { AuthAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await AuthAPI.me();
      setUser(u);
      return u;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me check when handling OAuth callback (AuthCallback will set session)
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const res = await AuthAPI.login({ email, password });
    localStorage.setItem('dz_token', res.access_token);
    setUser(res.user);
    return res.user;
  };

  const register = async (data) => {
    const res = await AuthAPI.register(data);
    localStorage.setItem('dz_token', res.access_token);
    setUser(res.user);
    return res.user;
  };

  const logout = async () => {
    try { await AuthAPI.logout(); } catch { /* server logout failed (network/401) — proceed with local cleanup */ }
    localStorage.removeItem('dz_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
